import DocumentView from "./DocumentView.component";

export default DocumentView;
